/* eslint-disable */

export const protobufPackage = "od_protos.sell.seller.data";

/**
 * Policy contains simple data fields which govern what actions should
 * be taken for the lead.
 *
 * Next ID: 9
 */
export interface Policy {
  /** Whether we can show comps as part of the offer or not. */
  showComps: boolean;
  /**
   * Whether the lead is qualified for marketplace or not.
   *
   * @deprecated
   */
  marketplace: boolean;
  /**
   * Experiment flags
   *
   * @deprecated
   */
  expAug2019CepPilot: boolean;
  /** Opendoor direct offer will be an automated offer. */
  opendoorDirectAutomatedOffer: boolean;
}

/**
 * OfferPolicy contains data which govern what actions should be taken for the
 * offer and what the seller's experience should be like.
 *
 * Next ID: 5
 */
export interface OfferPolicy {
  tradeInShowOnClosingDash: boolean;
  tradeInShowOnOfferPage: boolean;
  /** @deprecated */
  expAug2019TradeInRefreshed: boolean;
}

function createBasePolicy(): Policy {
  return { showComps: false, marketplace: false, expAug2019CepPilot: false, opendoorDirectAutomatedOffer: false };
}

export const Policy = {
  fromJSON(object: any): Policy {
    return {
      showComps: isSet(object.show_comps) ? Boolean(object.show_comps) : false,
      marketplace: isSet(object.marketplace) ? Boolean(object.marketplace) : false,
      expAug2019CepPilot: isSet(object.expAug2019CepPilot) ? Boolean(object.expAug2019CepPilot) : false,
      opendoorDirectAutomatedOffer: isSet(object.opendoorDirectAutomatedOffer)
        ? Boolean(object.opendoorDirectAutomatedOffer)
        : false,
    };
  },

  toJSON(message: Policy): unknown {
    const obj: any = {};
    if (message.showComps === true) {
      obj.show_comps = message.showComps;
    }
    if (message.marketplace === true) {
      obj.marketplace = message.marketplace;
    }
    if (message.expAug2019CepPilot === true) {
      obj.expAug2019CepPilot = message.expAug2019CepPilot;
    }
    if (message.opendoorDirectAutomatedOffer === true) {
      obj.opendoorDirectAutomatedOffer = message.opendoorDirectAutomatedOffer;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Policy>, I>>(base?: I): Policy {
    return Policy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Policy>, I>>(object: I): Policy {
    const message = createBasePolicy();
    message.showComps = object.showComps ?? false;
    message.marketplace = object.marketplace ?? false;
    message.expAug2019CepPilot = object.expAug2019CepPilot ?? false;
    message.opendoorDirectAutomatedOffer = object.opendoorDirectAutomatedOffer ?? false;
    return message;
  },
};

function createBaseOfferPolicy(): OfferPolicy {
  return { tradeInShowOnClosingDash: false, tradeInShowOnOfferPage: false, expAug2019TradeInRefreshed: false };
}

export const OfferPolicy = {
  fromJSON(object: any): OfferPolicy {
    return {
      tradeInShowOnClosingDash: isSet(object.tradeInShowOnClosingDash)
        ? Boolean(object.tradeInShowOnClosingDash)
        : false,
      tradeInShowOnOfferPage: isSet(object.tradeInShowOnOfferPage) ? Boolean(object.tradeInShowOnOfferPage) : false,
      expAug2019TradeInRefreshed: isSet(object.expAug2019TradeInRefreshed)
        ? Boolean(object.expAug2019TradeInRefreshed)
        : false,
    };
  },

  toJSON(message: OfferPolicy): unknown {
    const obj: any = {};
    if (message.tradeInShowOnClosingDash === true) {
      obj.tradeInShowOnClosingDash = message.tradeInShowOnClosingDash;
    }
    if (message.tradeInShowOnOfferPage === true) {
      obj.tradeInShowOnOfferPage = message.tradeInShowOnOfferPage;
    }
    if (message.expAug2019TradeInRefreshed === true) {
      obj.expAug2019TradeInRefreshed = message.expAug2019TradeInRefreshed;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<OfferPolicy>, I>>(base?: I): OfferPolicy {
    return OfferPolicy.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<OfferPolicy>, I>>(object: I): OfferPolicy {
    const message = createBaseOfferPolicy();
    message.tradeInShowOnClosingDash = object.tradeInShowOnClosingDash ?? false;
    message.tradeInShowOnOfferPage = object.tradeInShowOnOfferPage ?? false;
    message.expAug2019TradeInRefreshed = object.expAug2019TradeInRefreshed ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
